import React from "react";
import {
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalText,
  AcceptButton,
} from "./DietDisclaimerModal.styled";

const DietDisclaimerModal = ({ onAccept, show }) => {
  if (!show) {
    return null;
  }

  return (
    <ModalOverlay>
      <ModalContent>
        <ModalHeader>Ważne Ostrzeżenie</ModalHeader>
        <ModalText>
          <strong>Doradca Dietetyczny</strong> to narzędzie wspomagające, które nie zastępuje profesjonalnej porady medycznej ani zdrowotnej.
        </ModalText>
        <ModalText>
          Informacje i sugestie generowane przez tego asystenta <strong>nie stanowią porady medycznej, zdrowotnej ani dietetycznej</strong> i nie mogą być traktowane jako oficjalna opinia specjalisty.
        </ModalText>
        <AcceptButton onClick={onAccept}>
          Rozumiem i akceptuję
        </AcceptButton>
      </ModalContent>
    </ModalOverlay>
  );
};

export default DietDisclaimerModal;

